import { SuppressKeyboardEventParams } from 'ag-grid-community'

// ステータス列のキーボード操作を制御する suppressKeyboardEvent ハンドラ。
// - 非編集中 Enter: 編集可能セルならドロップダウン編集を開始する (既定の下移動を上書き)。
// - 編集中 上下キー: grid のセル移動/スクロールを抑制し、エディタ内の選択肢移動に委ねる。
// - 編集中 Enter: grid に処理させず、エディタ側で確定＋下移動を行うため抑制する。
export const handleStatusCellKeyboardEvent = <T>(
  params: SuppressKeyboardEventParams<T>
): boolean => {
  const { event, editing, column, node, api } = params

  if (editing) {
    return (
      event.key === 'ArrowUp' ||
      event.key === 'ArrowDown' ||
      event.key === 'Enter'
    )
  }

  if (event.key !== 'Enter') return false
  if (!column.isCellEditable(node)) return false
  const rowIndex = node.rowIndex
  if (rowIndex == null) return false
  api.startEditingCell({ rowIndex, colKey: column.getColId() })
  return true
}
